module.exports = __webpack_public_path__ + "static/media/close-white.fc154319.svg";